import(/* webpackMode: "eager" */ "/Users/gwrunner/actions-runner/GHA-2-M4A/_work/FBO/FBO/Procom.Phoenix.Web/Phoenix/microapps/workflow-hub-v2/app/page.tsx");
